// styles/Registration.styles.js
import theme from './../../theme';

const RegistrationStyles = {
  container: {
    minHeight: '100vh',
    backgroundColor: theme.colors.black, // Dark theme background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  paper: {
    padding: '40px',
    maxWidth: '400px',
    backgroundColor: theme.colors.extraLightGray, // Light paper background for contrast
    borderRadius: '12px',
    boxShadow: theme.shadows.medium,
  },
  avatar: {
    margin: '10px',
    backgroundColor: theme.colors.green,
  },
  form: {
    marginTop: '24px',
    width: '100%',
  },
  textField: {
    marginBottom: '16px',
  },
  radioGroup: {
    marginBottom: '16px',
  },
  registerButton: {
    marginTop: '16px',
    marginBottom: '16px',
    backgroundColor: theme.colors.green,
    color: theme.colors.white,
    '&:hover': {
      backgroundColor: theme.colors.greenHover || '#6aa832', // Slightly darker hover effect
    },
  },
};

export default RegistrationStyles;
